import { Box, styled } from '@mui/material';
import { ITaskSearchParam } from 'wisestep-api';
import { WsColors } from 'wisestep-base';

import { ListingSearchPropsForNotesListing } from '../../../features/clientDetails/components/notes/helper/notesHelper';

export const notesDefaultFilterValues = {
  search: '',
  fromDate: '',
  toDate: '',
  createdBy: [],
  clientIds: [],
  contactIds: [],
  clients: [],
  contacts: [],
  tags: [],
  reminderStatus: '',
  type: '',
  searchAcross: [],
  noteType: '',
  clientNames: [],
};

export const getFilterValue = (
  fieldName: string,
  methods,
  defaultSearchFiltersValues?: ListingSearchPropsForNotesListing
) => {
  if (defaultSearchFiltersValues?.type === 'client' && fieldName === 'clients') {
    return (defaultSearchFiltersValues?.clientIds?.length ?? 0) > 0 ? 'Selected 1' : 'All';
  }

  if (defaultSearchFiltersValues?.type === 'client' && fieldName === 'contacts') {
    return (defaultSearchFiltersValues?.contactIds?.length ?? 0) > 0 ? 'Selected 1' : 'None';
  }

  if (defaultSearchFiltersValues?.type === 'client_contact' && fieldName === 'contacts') {
    return (defaultSearchFiltersValues?.contactIds?.length ?? 0) > 0 ? 'Selected 1' : 'All';
  }

  if (defaultSearchFiltersValues?.type === 'client_contact' && fieldName === 'clients') {
    return (defaultSearchFiltersValues?.clientIds?.length ?? 0) > 0 ? 'Selected 1' : 'None';
  }

  const fieldValue = methods.watch(fieldName);

  if (Array.isArray(fieldValue)) {
    return fieldValue.length > 0 ? `Selected ${fieldValue.length}` : `All`;
  }
  return fieldValue ? `Selected 1` : `All`;
};

export const stripHtmlTags = (html) => {
  return html ? html.replace(/<[^>]+>/g, '') : '';
};

export const NotesBoxWithRadius = styled(Box)<{ status: string }>(({ status }) => ({
  border: '1px solid',
  borderColor: status === 'OPEN' ? WsColors.Yellow100 : WsColors.Green500,
  backgroundColor: status === 'OPEN' ? WsColors.Yellow200 : WsColors.Green500,
  borderRadius: 4,
  paddingLeft: 8,
  paddingRight: 8,
  height: 30,
  alignItems: 'center',
}));

export const TaskDefaultQuery: ITaskSearchParam = {
  searchType: '',
  status: '',
  dueFromDateTime: null,
  dueTillDateTime: null,
  createdFromDateTime: null,
  createdTillDateTime: null,
  updatedFromDateTime: null,
  updatedTillDateTime: null,
  createdBy: [],
  team: [],
  sort: 'due_date',
  sortDirection: 'DESC',
  size: 50,
  page: 0,
  keywords: '',
};
export const leadTypes = ['All Leads', 'My Leads'];

export const noteTypes = ['All Notes', 'My Notes', 'Unmarked Notes'];

export const getNoteTypeLabel = (noteType?: string): string => {
  const noteTypeLabels = {
    my_notes: 'My Notes',
    unmarked_notes: 'Unmarked Notes',
    all_notes: 'All Notes',
  };

  return noteTypeLabels[noteType ?? 'all_notes'] || 'All Notes';
};
